import { Injectable } from '@angular/core';
import { EditorFilter, FilterCondition, EditorFilterTreeNode } from './filter-administration.model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor() { }

  public removeConditionFromFilter(filter: EditorFilter, nodeToRemove: FilterCondition) {
    this.removeConditionFromNode(filter.rootNode, nodeToRemove);
  }

  private removeConditionFromNode(node: EditorFilterTreeNode, nodeToRemove: FilterCondition) {

    nodeToRemove.deleted = true;
    if (nodeToRemove.id <= 0) {
      const indexOf = node.conditions.indexOf(nodeToRemove);
      if (indexOf > -1) {
        node.conditions.splice(indexOf, 1);
      }
    }

    for (const childNode of node.nodes) {
      this.removeConditionFromNode(childNode, nodeToRemove);
    }
  }
}
